export default function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/mickwaanders/Downloads/BOOOM 3/node_modules/swiper/esm/components/core/events/onClick.js
// module id = 65
// module chunks = 0